/**
 * In this file we handel to show the OTP popup screen and OTP Verify logic
 **/
import { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function AddMedicalInfoModal(props) {
	//Intial state declaraction
	// eslint-disable-next-line
	const [modal,setModal]=useState({});
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	//To close modal
	// eslint-disable-next-line
	const handleClose=()=>setModal({});
  return (
    <Modal
      show={props?.data?.addInfo}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title" id="AddMedicalInfoModalLabel"><span className="member-name text-capitalize">{props.data.name}{t('common.possessive_suffix')} </span> {t('profile.addMedInfo')}</h5>
		</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
			<div className="col-lg-6 mb-4 d-grid">
				<Link to={role===4 ? '/hospital/admin/add-development/'+props?.data?.member : '/physician/add-development/'+props?.data?.member}>
					<button type="button" className={`btn btn-block ${role===4?'btn-outline-tmAquaGreen':'btn-outline-tmPink'}`} style={{ width: "100%"}}>
						<i className="fa-solid fa-chart-column fw-bolder"></i> <br/> {t('common.addDevelopment')}
					</button>
				</Link>
			</div>
			<div className="col-lg-6 mb-4 d-grid">
				<Link to={role===4 ? '/hospital/admin/add-measurement/'+props?.data?.member:'/physician/add-measurement/'+props?.data?.member}>
					<button type="button" className={`btn btn-block ${role===4?'btn-outline-tmAquaGreen':'btn-outline-tmPink'}`} style={{ width: "100%"}}>
						<i className="fa-solid fa-weight-scale fw-bolder"></i> <br/> {t('common.addMeasurement')}
					</button>
				</Link>
			</div>
			<div className="col-lg-6 mb-4 d-grid">
				<Link to={role===4 ? '/hospital/admin/add-medical-issues/'+props?.data?.member:'/physician/add-medical-issues/'+props?.data?.member}>
					<button type="button" className={`btn btn-block ${role===4?'btn-outline-tmAquaGreen':'btn-outline-tmPink'}`} style={{ width: "100%"}}>
						<i className="fa-solid fa-hospital-user fw-bolder"></i> <br/> {t('common.addMedicalIssues')}
					</button>
				</Link>
			</div>
			<div className="col-lg-6 mb-4 d-grid">
				<Link to={role===4 ?'/hospital/admin/add-vaccination/'+props?.data?.member:'/physician/add-vaccination/'+props?.data?.member}>
					<button type="button" className={`btn btn-block ${role===4?'btn-outline-tmAquaGreen':'btn-outline-tmPink'}`} style={{ width: "100%"}}>
						<i className="fa-solid fa-syringe fw-bolder"></i> <br/> {t('common.addVaccination')}
					</button>
				</Link>
			</div>
		</div>
      </Modal.Body>
    </Modal>
  );
}

export default AddMedicalInfoModal;
